import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const classGroups: Record<string, string[]> = {
  typography: [
    'display-medium',
    'display-small',
    'title-extra-large',
    'title-large',
    'title-medium',
    'title-small',
    'title-extra-small',
    'body-large-basic',
    'body-large-emphasis',
    'body-medium-basic',
    'body-medium-emphasis',
    'body-medium-underline',
    'body-small-basic',
    'body-small-emphasis',
    'body-small-bold',
    'body-small-italic',
    'body-small-underline',
    'caption-basic',
    'caption-emphasis',
    'caption-italic',
  ],
}

const twMerge = extendTailwindMerge({
  extend: {
    classGroups,
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
